import React from 'react';
import Login from '../components/student/Login';

const ScreenLogin = () => {
  return <Login />;
};

export default ScreenLogin;
